/**
 * GA4 Analytics helper — fires custom events via gtag.
 * Safe no-op if gtag is not loaded.
 */
export function trackEvent(eventName, params = {}) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
}
